<!-- <mat-toolbar color="primary">
    <button [fxShow.lt-md]="true" [fxShow]="false"  mat-icon-button (click)="openSidenav()">
            <mat-icon>menu</mat-icon>
        </button>
    <span>Accounting Distribution</span>
</mat-toolbar> -->
<div class="content" fxLayout="column" fxLayout.sm="column" fxLayout.xs="column" fxLayoutGap="16px" [@routeAnimation]="true">
    <nav mat-tab-nav-bar fxLayout="row" mat-stretch-tabs>
        <a mat-tab-link routerLink="company" routerLinkActive #rla1="routerLinkActive" [active]="rla1.isActive">
                Company
            </a>
        <a mat-tab-link routerLink="org" routerLinkActive #rla2="routerLinkActive" [active]="rla2.isActive">
                Org
            </a>
        <a mat-tab-link routerLink="account" routerLinkActive #rla3="routerLinkActive" [active]="rla3.isActive">Account
            </a>
        <a mat-tab-link routerLink="project-task" routerLinkActive #rla4="routerLinkActive" [active]="rla4.isActive">
                Project/Task
            </a>
        <a mat-tab-link routerLink="exp-type" routerLinkActive #rla5="routerLinkActive" [active]="rla5.isActive">
                Exp Type
            </a>
        <a mat-tab-link routerLink="exp-org" routerLinkActive #rla6="routerLinkActive" [active]="rla6.isActive">
                Exp Org
            </a>
        <a mat-tab-link routerLink="oebs-config" routerLinkActive #rla7="routerLinkActive" [active]="rla7.isActive" *ngIf="hasRole('DEV')">
        OeBS Config</a>
    </nav>
    <router-outlet></router-outlet>
</div>